import { BlocksIconWarningDiamondFilled } from 'blocks-nextjs/blocks-web-components/components/icon/icons/warning-diamond-filled';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconWarningDiamondFilled = createComponent({
  react: React,
  tagName: 'cat-icon-warning-diamond-filled',
  elementClass: BlocksIconWarningDiamondFilled
});
